import React, { Component } from 'react'
import get from 'lodash/get'
import View from './component'
import { useQuery } from '@apollo/client'
import { GET_EMBED } from 'Queries'
import Loading from './components/Loading'
import { NotFound, ErrorView } from 'Blocks'

const EmbedPageContainer = () => {
  const {
    match: { params }
  } = this.props

  const variables = {
    arguments: {
      uuid: params.uuid
    }
  }

  const { loading, error, data } = useQuery(GET_EMBED, { variables })

  if (loading) return <Loading />
  if (error) return <ErrorView message={error.message} error={error} />
  const products = get(
    data,
    'content.layout.collections[0].preview.products',
    []
  )
  if (products) {
    return <View {...{ products }} />
  } else {
    return <NotFound staticContext={this.props.staticContext} />
  }
}

export default EmbedPageContainer
